// For Firebase JS SDK v7.20.0 and later, measurementId is optional

import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyDsL_3Tl5YWO3104LF5oGL7MuwQJnG3ScQ",
  authDomain: "to-do-list-666bf.firebaseapp.com",
  projectId: "to-do-list-666bf",
  storageBucket: "to-do-list-666bf.appspot.com",
  messagingSenderId: "620322060528",
  appId: "1:620322060528:web:916ee407f5bcfa1bd5aa35",
  measurementId: "G-GDFRD9LB5V",
});

const db = firebaseApp.firestore();

export default db;
